import { render, staticRenderFns } from "./DialogSearchConsentDetail.vue?vue&type=template&id=3ae0ad6c&"
import script from "./DialogSearchConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DialogSearchConsentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports